<package-receive-progress></package-receive-progress>

<div class="steps-content">
  <p-card>
    <ng-template pTemplate="title">
      Package Label
    </ng-template>
    <ng-template pTemplate="subtitle">
      Please print and attach this label to the package. If the package already has a label then cover it with this one.
    </ng-template>
    <ng-template pTemplate="content">
      <div class="row">
        <div class="col-2">
        </div>
        <div class="col-8">
          <div class="print-container align-content-center">
            <div id="label">
              <div class="print-label align-content-center">
                <div class="row">
                  <div class="col-12">
                    <div style="font-size: x-large; width: 4in; border: solid 3px black; border-bottom: solid 3px black; margin-bottom: 20px; padding: 20px;">
                      <b>{{package.shipmentTypeDisplay}}</b><br />
                      <!--{{package.DeliveredDate | date:'MM/dd/yyyy hh:mm a'}}-->
                    </div>
                  </div>
                  <div class="col-12">
                    <div style="font-size: x-large; width: 4in; border: solid 3px black; border-bottom: solid 3px black; margin-bottom: 20px; padding: 20px;">
                      <b>{{package.FromName}}</b><br />
                      {{package.FromAddress1}}<br />
                      {{package.FromCity}} {{package.FromState}} {{package.FromZipCode}}
                    </div>
                  </div>
                  <div class="col-12">
                    <ngx-barcode6 [bc-value]="package.trackingNumber" [bc-display-value]="true"></ngx-barcode6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2">
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="grid p-nogutter p-justify-between">
        <button class="navbutton" (click)="prevPage()" icon="pi pi-angle-left">Back</button>
        <button class="navbutton" printSectionId="label" ngxPrint (click)="nextEnabled=true" ><i class="fa fa-print"></i> Print Label</button>
        <button [disabled]="!nextEnabled" class="navbutton" (click)="nextPage()" icon="pi pi-angle-right" iconPos="right">Next</button>
      </div>
    </ng-template>
  </p-card>
</div>
<p-toast>
</p-toast>
